import { Request } from 'commons/utils/request'
import { DocumentEditWebPageResponse } from '~bank-documents/types/documentEdit'

export const getDocumentEditModeWebPage = (id: number) =>
  Request.post<DocumentEditWebPageResponse, { id: number }>(Request.urls.bank.documentEditPage, { id })
